module.exports = __webpack_public_path__ + "static/HeliosRed-1f3ee6022c9cec47124b0e0b9e2d809a.jpg";